export const seoIndex = {
  en: {
    title:
      "Virtual Tour Blog | Create 360 Tours with AI | Travvir - Smartphone Virtual Tours",
    description:
      "Discover how to create professional 360 virtual tours using your smartphone. Learn about AI-powered panoramas, virtual tour apps, and step-by-step guides for beginners.",
    keywords:
      "360 virtual tour, smartphone virtual tour, AI virtual tour, 360 photo app, panorama app, virtual tour guide, 360 camera app, immersive virtual tours, virtual tour tutorial",
    ogTitle:
      "Virtual Tour Blog | AI-Powered 360 Tours from Your Smartphone | Travvir",
    ogDescription:
      "Master the art of creating stunning 360 virtual tours with your smartphone. Expert guides, tips, and AI technology insights for virtual tour creators.",
    twitterTitle: "Virtual Tour Blog | Create 360 Tours with AI | Travvir",
    twitterDescription:
      "Learn how to create professional 360 virtual tours using your smartphone with AI-powered technology.",
    schemaName: "Travvir Virtual Tour Blog",
    schemaDescription:
      "Guides, tutorials, and product updates for creating 360 virtual tours with smartphones",
  },

  fr: {
    title: "Blog Visite Virtuelle | Créer des Tours 360 avec l'IA | Travvir",
    description:
      "Découvrez comment créer des visites virtuelles 360 professionnelles avec votre smartphone. Guides sur les panoramas IA, les applications de tour virtuel et des tutoriels pas à pas.",
    keywords:
      "visite virtuelle 360, tour virtuel smartphone, visite virtuelle IA, application panorama 360, guide visite virtuelle, application caméra 360, visites virtuelles immersives",
    ogTitle:
      "Blog Visite Virtuelle | Tours 360 Propulsés par l'IA depuis votre Smartphone | Travvir",
    ogDescription:
      "Maîtrisez l'art de créer de superbes visites virtuelles 360 avec votre smartphone. Guides experts et conseils pour les créateurs de tours virtuels.",
    twitterTitle:
      "Blog Visite Virtuelle | Créer des Tours 360 avec l'IA | Travvir",
    twitterDescription:
      "Apprenez à créer des visites virtuelles 360 professionnelles avec votre smartphone grâce à la technologie IA.",
    schemaName: "Blog de Visite Virtuelle Travvir",
    schemaDescription:
      "Guides, tutoriels et mises à jour produit pour créer des tours virtuels 360 avec smartphones",
  },

  es: {
    title: "Blog de Tour Virtual | Crear Tours 360 con IA | Travvir",
    description:
      "Descubre cómo crear recorridos virtuales 360 profesionales con tu smartphone. Aprende sobre panoramas con IA, aplicaciones de tour virtual y guías paso a paso para principiantes.",
    keywords:
      "tour virtual 360, recorrido virtual smartphone, tour virtual IA, app panorama 360, guía tour virtual, app cámara 360, recorridos virtuales inmersivos",
    ogTitle:
      "Blog de Tour Virtual | Tours 360 con IA desde tu Smartphone | Travvir",
    ogDescription:
      "Domina el arte de crear impresionantes tours virtuales 360 con tu smartphone. Guías expertas y consejos para creadores de recorridos virtuales.",
    twitterTitle: "Blog de Tour Virtual | Crear Tours 360 con IA | Travvir",
    twitterDescription:
      "Aprende a crear recorridos virtuales 360 profesionales con tu smartphone usando tecnología IA.",
    schemaName: "Blog de Tour Virtual Travvir",
    schemaDescription:
      "Guías, tutoriales y actualizaciones de producto para crear tours virtuales 360 con smartphones",
  },

  de: {
    title: "Virtual Tour Blog | 360° Touren mit KI erstellen | Travvir",
    description:
      "Entdecken Sie, wie Sie professionelle 360° Virtual Tours mit Ihrem Smartphone erstellen. Lernen Sie über KI-gestützte Panoramen, Virtual-Tour-Apps und Schritt-für-Schritt-Anleitungen für Einsteiger.",
    keywords:
      "360 virtual tour, smartphone virtual tour, KI virtual tour, 360 foto app, panorama app, virtual tour anleitung, 360 kamera app, immersive virtual tours, virtual tour erstellen",
    ogTitle:
      "Virtual Tour Blog | KI-gestützte 360° Touren vom Smartphone | Travvir",
    ogDescription:
      "Meistern Sie die Kunst, beeindruckende 360° Virtual Tours mit Ihrem Smartphone zu erstellen. Expertenanleitungen, Tipps und KI-Technologie-Einblicke für Virtual-Tour-Ersteller.",
    twitterTitle:
      "Virtual Tour Blog | 360° Touren mit KI erstellen | Travvir",
    twitterDescription:
      "Lernen Sie, wie Sie professionelle 360° Virtual Tours mit Ihrem Smartphone und KI-gestützter Technologie erstellen.",
    schemaName: "Travvir Virtual Tour Blog",
    schemaDescription:
      "Anleitungen, Tutorials und Produktupdates zum Erstellen von 360° Virtual Tours mit Smartphones",
  },
};
